import { getAuthCode } from "./getAuthCode";
export const fetchAccountData = async (setUserDetails) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/retrieveaccountsettings", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      setUserDetails(result);
    } catch (error) {
      console.log(error);
    }
  };